module.exports = __webpack_public_path__ + "static/70-3fa7d62a68b010cf632c04db59da235c.png";